/**
 * CSRF token cache for the SPA. The token comes from GET /api/csrf (the paired cookie is
 * httpOnly, so JS can't read it) and is echoed in the x-csrf-token header on every write.
 * Cached for the session; `mcpWrite` clears + refetches once if the server reports the
 * token expired (e.g. session rotated).
 */
import { api } from './api';

let cached: string | null = null;

export async function getCsrfToken(force = false): Promise<string> {
  if (cached && !force) return cached;
  cached = (await api<{ csrfToken: string }>('/csrf')).csrfToken;
  return cached;
}

export function clearCsrfToken(): void {
  cached = null;
}
